import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import AuthReducer from './auth.reducer';
import RegisterReducer from './register.reducer';
import FinancialModelReducer from './financialModel.reducer';

export const reducers = (history) => ({
  router: connectRouter(history),
  AuthReducer,
  RegisterReducer,
  FinancialModelReducer
});

export default (history) => combineReducers(reducers(history));
